const AwardPointsComponent = (props) => {
  const { customComponentName, definition, showTitleOnly = false } = props;

  const points =
    definition?.outcomeRules?.[0]?.ruleData?.points ??
    definition?.outcomeDefinition?.outcomeRules?.[0]?.ruleData?.points;
  // Format the component name from "abc-def-ghi" to "Abc Def Ghi"
  const formatComponentName = (name) => {
    if (!name) return "";

    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formattedName = formatComponentName(customComponentName);
  const title =
    definition?.outcomeDefinition?.name || formattedName || "Unknown Component";

  if (showTitleOnly) {
    return (
      <div className="additional-fields-container">
        <h5>{title}</h5>
      </div>
    );
  }

  return (
    <div className="additional-fields-container">
      <h5>
        {title}: {points}
      </h5>
    </div>
  );
};

export default AwardPointsComponent;
